module.exports = __webpack_public_path__ + "static/media/gif.feb94468.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/gif.png
// module id = 75
// module chunks = 0